import { AboutPage } from "./About";
export default AboutPage;
